import React, { useEffect, useState } from 'react';
import { SelectButton } from 'primereact/selectbutton';
import ManagerHome from './views/manager-home';
import ManagerApproval from './views/manager-approval';
import ManagerUserLeaves from './views/manager-user-leaves';
import ManagerTeamLeaves from './views/manager-team-leaves';
import ManagerUpcomingEvents from './views/manager-upcoming-events';
import { Calendar } from "primereact/calendar";
import { leaveService } from '../../services/extensions';
import './styles/style.scss';
const ManagerDashboard = () => {
    const [selItem, setSelItem] = useState('Manager Dashboard');
    const [dates, setDates] = useState(new Date());
    const items = ['Manager Dashboard', 'Approvals', 'Team Leaves', 'Team Calendar', 'Upcoming Events'];
    const [approvals, setApprovals] = useState([]);
    const [rView, setRView] = useState('Calendar');

    useEffect(() => {
        fetchInReviewLeaves();
    }, [])

    const fetchInReviewLeaves = () => {
        leaveService.getReviewLeavesForSuperior().then(resp => {
            try {
                setApprovals(resp.data.data)
            } catch (error) {
                //error
            }
        }).catch(err => {
            console.log("Errror on fetching requests for approvals");
        })
    };


    return (
        <div className='ess-page'>
            <div className='grid' >
                <div className='col-12'>
                    {/* <h1 style={{ textTransform: 'uppercase', letterSpacing: '2px' }}>{selItem}</h1> */}
                    <SelectButton className='btn_container' value={selItem} options={items} onChange={(e) => setSelItem(e.value)} />
                </div>
                <div className='col-12' style={{ textAlign: 'right' }}>
                    <div style={{ display: 'inline-block', float: 'right' }}>
                        {['Manager Dashboard', 'Team Leaves'].includes(selItem) && <Calendar id="monthpicker" value={dates}
                            onChange={(e) => setDates(e.value)} view="month" dateFormat="mm-yy" yearNavigator yearRange={"2010:" + new Date().getFullYear().toString()} showIcon />}
                        {(['Team Calendar'].includes(selItem) && rView === 'Grid') && <Calendar id="monthpicker" value={dates}
                            onChange={(e) => setDates(e.value)} view="month" dateFormat="mm-yy" yearNavigator yearRange={"2010:" + new Date().getFullYear().toString()} showIcon />}
                    </div>
                    {selItem === 'Team Calendar' && <div className='pr-3' style={{ display: 'inline-block', float: 'right' }}>
                        <SelectButton value={rView} options={['Grid', 'Calendar']} onChange={(e) => setRView(e.value)} />
                    </div>}
                </div>
            </div>
            <hr />
            <div className=''>
                <div className='ess-table'>
                    {selItem === 'Manager Dashboard' && <ManagerHome date={dates} />}
                    {selItem === 'Approvals' && <ManagerApproval reload={fetchInReviewLeaves} data={approvals} duration={dates} />}
                    {selItem === 'Team Leaves' && <ManagerUserLeaves duration={dates} />}
                    {selItem === 'Team Calendar' && <ManagerTeamLeaves duration={dates} reportView={rView} />}
                    {selItem === 'Upcoming Events' && <ManagerUpcomingEvents duration={dates} />}

                </div>
            </div>
        </div >
    )
}

export default ManagerDashboard